<template>
  <v-dialog
    v-model="isOpen"
    max-width="1000"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline">
        <div class="columns">
          <div class="column" v-if="isCreate">
            <h2 class="title is-3">Создать коллекцию</h2>
          </div>
          <div class="column" v-if="!isCreate">
            <h2 class="title is-3">Изменить коллекцию: {{ currentChildName }}</h2>
          </div>
        </div>
      </v-card-title>
      <v-card-text>

        <v-row>
          <!-- Родитель -->
          <v-col>
            <h2 class="title is-6 font-weight-bold error--text">Родитель</h2>
            <div style="display: flex; flex-direction: column; gap: 10px;">
              <v-select
                outlined
                dense
                hide-details
                clearable
                :items="collections"
                item-value="id"
                item-text="name"
                label="Коллекция родителя"
                v-model="currentChild.parent_collection_id"
                @change="updateParentFields"
              ></v-select>
            </div>
          </v-col>

          <!-- Деть -->
          <v-col>
            <h2 class="title is-6 font-weight-bold error--text">Ребёнок</h2>
            <div style="display: flex; flex-direction: column; gap: 10px;">
              <v-select
                outlined
                dense
                hide-details
                clearable
                :items="firebases.results"
                item-value="id"
                item-text="name"
                label="Мостик ребёнка"
                :value="currentChild.child && currentChild.child.firebase_id"
                @input="getCollections($event, true)"
              ></v-select>

              <v-select
                outlined
                dense
                hide-details
                clearable
                :items="collections_child"
                item-value="id"
                item-text="name"
                label="Коллекция ребёнка"
                v-model="currentChild.child_collection_id"
                @change="updateChildFields"
              ></v-select>
            </div>
          </v-col>
        </v-row>

        <!-- СЕКЦИЯ МАППИНГА ПОЛЕЙ - ДОБАВИТЬ ПОСЛЕ ВЫБОРА КОЛЛЕКЦИЙ -->
        <v-row v-if="parentFields.length && childFields.length">
          <v-col>
            <h3 class="title is-5 mb-4">Сопоставление полей</h3>

            <div v-show="!isMappingValid" class="title is-5 mt-5 error--text">
              🆘 У родителя должно быть больше или столько же полей, сколько у ребёнка 🆘
            </div>

            <div class="columns">

              <!-- Поля родителя -->
              <v-col>
                <h4 class="subtitle is-6 mb-3">Родительские поля</h4>
                <draggable
                  v-model="parentFields"
                  class="fields-list"
                  group="fields"
                  v-bind="dragOptions"
                  @end="updateMappings"
                >
                  <transition-group type="transition">
                    <div v-for="field in parentFields" :key="field.name" class="mb-3 draggable-item card pa-4">
                      <div class="columns is-mobile is-vcentered">
                        <div class="column is-1">
                          <i class="icon mdi mdi-menu" style="font-size: 20px;"></i>
                        </div>
                        <div class="column">
                          <div class="field-info">
                            <span class="field-name has-text-weight-bold">{{ field.name }} </span>
                            <span class="field-type is-size-7 has-text-grey">({{ field.type }})</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </transition-group>
                </draggable>
              </v-col>

              <!-- Поля ребенка -->
              <v-col>
                <h4 class="subtitle is-6 mb-3">Дочерние поля</h4>
                <draggable
                  v-model="childFields"
                  class="fields-list"
                  group="fields"
                  v-bind="dragOptions"
                  @end="updateMappings"
                >
                  <transition-group type="transition">
                    <div v-for="field in childFields" :key="field.name" class="mb-3 draggable-item card pa-4">
                      <div class="columns is-mobile is-vcentered">
                        <div class="column is-1">
                          <i class="icon mdi mdi-menu" style="font-size: 20px;"></i>
                        </div>
                        <div class="column">
                          <div class="field-info">
                            <span class="field-name has-text-weight-bold">{{ field.name }} </span>
                            <span class="field-type is-size-7 has-text-grey">({{ field.type }})</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </transition-group>
                </draggable>
              </v-col>

            </div>
          </v-col>
        </v-row>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn
          text
          color="primary"
          :disabled="!isMappingValid"
          v-if="currentChild.id == null"
          @click="createChild()">
          Добавить
        </v-btn>
        <v-btn
          text
          color="primary"
          v-if="!isCreate"
          :disabled="!isMappingValid"
          @click="updateChild()">
          Обновить
        </v-btn>
      </v-card-actions>
      <overlay-loader :show="isLoading"></overlay-loader>
    </v-card>
  </v-dialog>
</template>

<script>
import draggable from 'vuedraggable';
import OverlayLoader from '@/app/shared/components/app-loader/Loader';

export default {
  name: 'CollectionDetailsModal',
  components: {
    OverlayLoader,
    draggable,
  },
  data() {
    return {
      currentChildName: '',

      parentFields: [],
      childFields: [],
      currentMappings: []
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        // Очищаем маппинг при открытии для создания
        if (this.isCreate) {
          this.parentFields = [];
          this.childFields = [];
          this.currentMappings = [];
        }

        this.getFirebases();
        this.currentChildName = this.currentChild.name;

        // для модалки изменения, подгрузка коллекций ребёнка
        if (this.currentChild.child_collection_id) {
          this.getCollections(this.currentChild.child.firebase_id, true).then(() => {
            // После загрузки дочерних коллекций загружаем родительские
            this.getCollections(this.idFirebase).then(() => {
              // И только потом обновляем поля
              if (!this.isCreate) {
                this.updateParentFields();
                this.updateChildFields();
              }
            });
          });
        } else {
          // Если нет дочерней коллекции, просто загружаем родительские
          this.getCollections(this.idFirebase).then(() => {
            if (!this.isCreate) {
              this.updateParentFields();
              this.updateChildFields();
            }
          });
        }
      }
    },
    collections: {
      handler(newCollections) {
        if (!this.isCreate && newCollections.length && this.currentChild.parent_collection_id) {
          // Небольшая задержка чтобы убедиться что все данные загружены
          setTimeout(() => {
            this.updateParentFields();
          }, 100);
        }
      },
      deep: true
    },
    collections_child: {
      handler(newCollections) {
        if (!this.isCreate && newCollections.length && this.currentChild.child_collection_id) {
          setTimeout(() => {
            this.updateChildFields();
          }, 100);
        }
      },
      deep: true
    }
  },
  created() {
    this.getFirebases();
    this.getCollections(this.idFirebase);
  },
  computed: {
    isMappingValid() {
      return this.parentFields.length >= this.childFields.length;
    },
    dragOptions() {
      return {
        animation: 100,
        scroll: true,
        scrollSensitivity: 100,
        scrollSpeed: 10,
      };
    },
    collections() {
      return this.$store.getters.GET_COLLECTIONS;
    },
    collections_child() {
      return this.$store.getters.GET_COLLECTIONS_CHILD;
    },
    firebases() {
      return this.$store.getters.GET_FIREBASES;
    },
    isCreate() {
      return this.currentChild.id === null;
    },
    currentChild: {
      get() {
        return this.$store.getters.CURRENT_CHILD;
      },
      set(value) {
        this.$store.commit('SET_CURRENT_CHILD', value);
      },
    },
    isLoading: {
      get() {
        return this.$store.getters.IS_DETAIL_CHILD_MODAL_LOADING;
      },
      set(value) {
        this.$store.commit('SET_DETAIL_CHILD_MODAL_LOADING', value);
      },
    },
    isOpen: {
      get() {
        return this.$store.getters.IS_DETAIL_CHILD_MODAL;
      },
      set() {
        this.$store.commit('SET_DETAIL_CHILD_MODAL', false);
      },
    },
    idFirebase() {
      return this.$route.params.idFirebase;
    }
  },
  methods: {
    updateMappings() {
      // Маппинг по позициям: первый с первым, второй со вторым и т.д.
      const mappings = {};
      const minLength = Math.min(this.parentFields.length, this.childFields.length);

      for (let i = 0; i < minLength; i++) {
        mappings[this.parentFields[i].name] = this.childFields[i].name;
      }

      // Сохраняем маппинги в currentChild
      this.currentChild.field_mappings = mappings;

      console.log('Current mappings:', this.currentChild.field_mappings);
    },
    getFirebases() {
      this.$store.dispatch("GET_FIREBASES", {page: 'all'}).catch(() => {
        this.$toast.error("Ошибка при получении мостиков");
      });
    },
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    },
    createChild() {
      let data = {
        collection: this.currentChild,
        firebase: this.idFirebase
      }
      this.$store.dispatch('CREATE_CHILD', data)
        .then(() => {
          this.$toast.success("Ребёнок создан!");
          this.$store.dispatch('GET_CHILDREN', this.idFirebase);
          this.close();
        })
        .catch((error) => {
          this.$toast.error("Ошибка при создании ребёнка");
        });
    },
    updateChild() {
      let data = {
        collection: this.currentChild,
        firebase: this.idFirebase
      }
      this.$store.dispatch('UPDATE_CHILD', data)
        .then(() => {
          this.$toast.success("Ребёнок обновлен!");
          this.$store.dispatch('GET_CHILDREN', this.idFirebase);
          this.close();
        })
        .catch((error) => {
          this.$toast.error("Ошибка при изменении коллекции");
        });
    },
    close() {
      // Очищаем маппинг полей
      this.parentFields = [];
      this.childFields = [];
      this.currentMappings = [];

      // Сбрасываем текущего ребенка
      this.$store.commit('SET_DEFAULT_CURRENT_CHILD');
      this.isOpen = false;
      this.isLoading = false;
    },
    getCollections(id, isChild = false) {
      if (id) {
        return this.$store.dispatch("GET_COLLECTIONS", {idFirebase: id, isChild: isChild})
          .then(() => {
            // После загрузки коллекций обновляем поля
            if (!this.isCreate) {
              this.updateParentFields();
              this.updateChildFields();
            }
          })
          .catch(() => {
            this.$toast.error("Ошибка загрузки коллекций");
          });
      }
    },

    updateParentFields() {
      console.log('updateParentFields called', {
        parentCollectionId: this.currentChild.parent_collection_id,
        collections: this.collections,
        field_mappings: this.currentChild.field_mappings
      });

      const parentCollection = this.collections.find(c => c.id === this.currentChild.parent_collection_id);
      const fields = parentCollection?.fields || [];
      console.log('Found parent collection:', parentCollection);

      // Восстанавливаем порядок полей из маппинга
      // сортировать все поля так, чтобы сначала шли сопоставленные (в порядке маппинга), а потом «сироты» без пары
      if (this.currentChild.field_mappings && Object.keys(this.currentChild.field_mappings).length > 0) {
        const mappedFields = Object.keys(this.currentChild.field_mappings);
        this.parentFields = fields.slice().sort((a, b) => {
          const ai = mappedFields.indexOf(a.name);
          const bi = mappedFields.indexOf(b.name);
          // mapped сначала, в порядке маппинга
          if (ai === -1 && bi === -1) return 0;
          if (ai === -1) return 1; // unmapped в конец
          if (bi === -1) return -1;
          return ai - bi;
        });
      } else {
        this.parentFields = fields;
      }

      // чтобы маппинг создался даже без перетаскивания
      // (исправление бага с пустым маппингом при создании)
      if (this.childFields.length) {
        this.updateMappings();
      }
    },

    updateChildFields() {
      const childCollection = this.collections_child.find(c => c.id === this.currentChild.child_collection_id);
      const fields = childCollection?.fields || [];

      // Восстанавливаем порядок полей из маппинга
      // сортировать все поля так, чтобы сначала шли сопоставленные (в порядке маппинга), а потом «сироты» без пары
      if (this.currentChild.field_mappings && Object.values(this.currentChild.field_mappings).length > 0) {
        const mappedFields = Object.values(this.currentChild.field_mappings);
        this.childFields = fields.slice().sort((a, b) => {
          const ai = mappedFields.indexOf(a.name);
          const bi = mappedFields.indexOf(b.name);
          if (ai === -1 && bi === -1) return 0;
          if (ai === -1) return 1;
          if (bi === -1) return -1;
          return ai - bi;
        });
      } else {
        this.childFields = fields;
      }

      // чтобы маппинг создался даже без перетаскивания
      // (исправление бага с пустым маппингом при создании)
      if (this.parentFields.length) {
        this.updateMappings();
      }
    }
  },
};
</script>

<style>
.drag-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.draggable-item {
  border: none !important;
  padding: 0px;
  background-color: #fff;
  position: relative;
}

.drag-handle {
  cursor: grab;
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
